"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Introduction = Introduction;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_markdown_1 = __importDefault(require("react-markdown"));
function Introduction({ calculator }) {
    const { intro } = calculator;
    return ((0, jsx_runtime_1.jsx)("div", { className: "koa:grid koa:gap-2 koa:max-w-prose koa:text-slate-600", children: (0, jsx_runtime_1.jsx)(react_markdown_1.default, { allowedElements: ["p", "strong", "em", "ul", "ol", "li", "a"], skipHtml: true, components: {
                a: ({ href, children }) => ((0, jsx_runtime_1.jsx)("a", { href: href, className: "koa:text-primary koa:hover:text-primary-hover koa:underline koa:hover:no-underline", target: "_blank", rel: "noopener noreferrer", children: children })),
            }, children: intro }) }));
}
